<template>
  <div class="home-bottom" v-if="bottomData.leftData">
    <div class="bottom-left" v-if="healthBigData && healthBigData[4].enable == 1 && healthBigData && healthBigData[5].enable == 1">
      <div class="left-title">员工概况</div>
      <div class="left-desc">过去7天</div>
      <div class="left-more" @click="goWork">查看更多</div>
      <div class="left-li">
        <img src="../../../assets/icon_onlineTime.png" alt="" />
        <div class="li-item">
          <div class="li-title">{{ bottomData.leftData.workTime }}</div>
          <div class="li-desc">在线时长</div>
        </div>
      </div>
      <div class="left-li">
        <img src="../../../assets/icon_responseTime.png" alt="" />
        <div class="li-item">
          <div class="li-title">{{ bottomData.leftData.eventWaitTime }}</div>
          <div class="li-desc">异常响应速度（平均）</div>
        </div>
      </div>
      <!-- <div class="left-li">
        <img src="../../../assets/icon_dealTime.png" alt="" />
        <div class="li-item">
          <div class="li-title">{{ bottomData.leftData.eventProcTime }}</div>
          <div class="li-desc">异常处理时长（平均）</div>
        </div>
      </div> -->
      <div class="left-li">
        <img src="../../../assets/icon_worker.png" alt="" />
        <div class="li-item">
          <div class="li-title">{{ bottomData.leftData.userCount }}</div>
          <div class="li-desc">注册护工数量</div>
        </div>
      </div>
    </div>
	<div class="bottom-left-big" v-if="healthBigData && healthBigData[4].enable == 1 && healthBigData && healthBigData[5].enable != 1">
	  <div class="left-title">员工概况</div>
	  <div class="left-desc">过去7天</div>
	  <div class="left-more" @click="goWork">查看更多</div>
	  <span class="left-li">
	    <img src="../../../assets/icon_onlineTime.png" alt="" />
	    <div class="li-item">
	      <div class="li-title">{{ bottomData.leftData.workTime }}</div>
	      <div class="li-desc">在线时长</div>
	    </div>
	  </span>
	  <span class="left-li">
	    <img src="../../../assets/icon_responseTime.png" alt="" />
	    <div class="li-item">
	      <div class="li-title">{{ bottomData.leftData.eventWaitTime }}</div>
	      <div class="li-desc">异常响应速度（平均）</div>
	    </div>
	  </span>
	  <!-- <div class="left-li">
	    <img src="../../../assets/icon_dealTime.png" alt="" />
	    <div class="li-item">
	      <div class="li-title">{{ bottomData.leftData.eventProcTime }}</div>
	      <div class="li-desc">异常处理时长（平均）</div>
	    </div>
	  </div> -->
	  <span class="left-li">
	    <img src="../../../assets/icon_worker.png" alt="" />
	    <div class="li-item">
	      <div class="li-title">{{ bottomData.leftData.userCount }}</div>
	      <div class="li-desc">注册护工数量</div>
	    </div>
	  </span>
	</div>
    <div class="bottom-right" v-if="healthBigData && healthBigData[5].enable == 1 && healthBigData[4].enable == 1">
      <div class="bottom-check">
        <div class="check-title" @click="goReal" v-if="healthBigData[6].enable">查看实时监测</div>
        <div class="check-title" v-else></div>
      </div>
      <div class="bottom-content">
		<div class="content-left">
			<div class="circle">
			  <div class="circle-title">{{ bottomData.dayNum }}</div>
			  <div class="circle-desc">守护天数</div>
			</div>
			<div class="total">
			  <div>累计报警：{{ bottomData.warning }}次</div>
			  <div>及时处理：{{ bottomData.warningFinish }}次</div>
			</div>
		</div>
		<div class="content-right">
        <div class="circle1">
          <div class="circle-title1">{{ bottomData.equipmentCount }}</div>
          <div class="circle-desc1">设备总数</div>
        </div>
        <div class="circle2">
          <div class="circle-title2">{{ bottomData.onlinePercent }}%</div>
          <div class="circle-desc2">设备在线率</div>
        </div>
        <div class="detail">
          <div class="detail-li">
            <img src="../../../assets/icon_working.png" alt="" />
            <div>监测中：{{ bottomData.curTime }}</div>
          </div>
          <div class="detail-li">
            <img src="../../../assets/warning-circle-fill.png" alt="" />
            <div>报警：{{ bottomData.untreated }}</div>
          </div>
          <div class="detail-li">
            <img src="../../../assets/icon_noworking.png" alt="" />
            <div>非监测时段：{{ bottomData.notCurTime }}</div>
          </div>
          <div class="detail-li">
            <img src="../../../assets/icon_dealing.png" alt="" />
            <div>处理中：{{ bottomData.processing }}</div>
          </div>
          <div class="detail-li">
            <img src="../../../assets/icon_offline.png" alt="" />
            <div>离线：{{ bottomData.offlineCount }}</div>
          </div>
          <div class="detail-li">
            <img src="../../../assets/check-circle-fill.png" alt="" />
            <div>已处理：{{ bottomData.complete }}</div>
          </div>
		  </div>
        </div>
      </div>
    </div>
	<div class="bottom-right-big" v-if="healthBigData && healthBigData[5].enable == 1 && healthBigData[4].enable != 1">
	  <div class="bottom-check">
	    <div class="check-title" @click="goReal" v-if="healthBigData[6].enable">查看实时监测</div>
		<div class="check-title" v-else></div>
	  </div>
	  <div class="bottom-content">
		<div class="content-left">
			<div class="circle">
			  <div class="circle-title">{{ bottomData.dayNum }}</div>
			  <div class="circle-desc">守护天数</div>
			</div>
			<div class="total">
			  <div>累计报警：{{ bottomData.warning }}次</div>
			  <div>及时处理：{{ bottomData.warningFinish }}次</div>
			</div>
		</div>
		<div class="content-right">
	    <div class="circle1">
	      <div class="circle-title1">{{ bottomData.equipmentCount }}</div>
	      <div class="circle-desc1">设备总数</div>
	    </div>
	    <div class="circle2">
	      <div class="circle-title2">{{ bottomData.onlinePercent }}%</div>
	      <div class="circle-desc2">设备在线率</div>
	    </div>
	    <div class="detail">
	      <div class="detail-li">
	        <img src="../../../assets/icon_working.png" alt="" />
	        <div>监测中：{{ bottomData.curTime }}</div>
	      </div>
	      <div class="detail-li">
	        <img src="../../../assets/warning-circle-fill.png" alt="" />
	        <div>报警：{{ bottomData.untreated }}</div>
	      </div>
	      <div class="detail-li">
	        <img src="../../../assets/icon_noworking.png" alt="" />
	        <div>非监测时段：{{ bottomData.notCurTime }}</div>
	      </div>
	      <div class="detail-li">
	        <img src="../../../assets/icon_dealing.png" alt="" />
	        <div>处理中：{{ bottomData.processing }}</div>
	      </div>
	      <div class="detail-li">
	        <img src="../../../assets/icon_offline.png" alt="" />
	        <div>离线：{{ bottomData.offlineCount }}</div>
	      </div>
	      <div class="detail-li">
	        <img src="../../../assets/check-circle-fill.png" alt="" />
	        <div>已处理：{{ bottomData.complete }}</div>
	      </div>
		  </div>
	    </div>
	  </div>
	</div>
  </div>
</template>

<script>
export default {
  props: {
  	  healthBigData: null,
  },
  data() {
    return {
      bottomData: {},
      bottomEmpty: false,
    };
  },
  created() {},
  mounted() {
    this.getData();
	
  },
  methods: {
    goReal() {
	  var t = 4;
	  if(this.healthBigData[0].enable != 1) t--;
	  if(this.healthBigData[4].enable != 1) t--;
      this.$parent.tabClick2(t);
    },
    goWork() {
	  var t = 3;
	  if(this.healthBigData[0].enable != 1) t--;
      this.$parent.tabClick2(t);
    },
    getData() {
      this.$get(
        "/api/deanData/getGeneralSituation",
        {},
        (res) => {
          if (res.code == 0) {
            if (res.data) {
              this.bottomData = res.data;
              this.bottomData.leftData.workTime =
                this.bottomData.leftData.workTime < 60
                  ? this.bottomData.leftData.workTime + "s"
                  : this.$formaTimeEn(
                      parseInt(this.bottomData.leftData.workTime / 60)
                    );
              this.bottomData.leftData.eventWaitTime =
                this.bottomData.leftData.eventWaitTime < 60
                  ? this.bottomData.leftData.eventWaitTime + "s"
                  : this.$formaTimeEn(
                      parseInt(this.bottomData.leftData.eventWaitTime / 60)
                    );
              this.bottomData.leftData.eventProcTime =
                this.bottomData.leftData.eventProcTime < 60
                  ? this.bottomData.leftData.eventProcTime + "s"
                  : this.$formaTimeEn(
                      parseInt(this.bottomData.leftData.eventProcTime / 60)
                    );
            } else {
              this.bottomEmpty = true;
            }
          } else {
          }
        },
        (err) => {
          console.log(err);
          // this.$message.error("服务端发生异常");
        }
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.home-bottom {
  width: 100%;
  height: 256px;
  margin-top: 0px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 30px;
  font-weight: 300;
  .bottom-left {
    width: 210px;
    height: 232px;
    background: #ffffff;
    box-shadow: 0px 3px 6px -2px rgba(0, 0, 0, 0.12);
    border-radius: 8px;
    .left-li {
      width: 100%;
      margin-top: 13px;
      img {
        width: 30px;
        margin-left: 10px;
      }
      .li-item {
        width: 145px;
        display: inline-block;
        margin-left: 15px;
        position: relative;
        top: 10px;
        .li-title {
          color: #262626;
          line-height: 20px;
          font-size: 20px;
        }
        .li-desc {
          color: #8c8c8c;
          line-height: 16px;
          font-size: 12px;
        }
      }
    }
    .left-title {
      color: #262626;
      line-height: 24px;
      font-size: 16px;
      margin: 10px 0 0 10px;
      display: inline-block;
    }
    .left-desc {
      color: #8c8c8c;
      line-height: 10px;
      font-size: 10px;
      display: inline-block;
      margin-left: 8px;
    }
    .left-more {
      color: #1890ff;
      line-height: 18px;
      font-size: 14px;
      display: inline-block;
      margin-left: 12px;

      cursor: pointer;
    }
  }
  .bottom-left-big {
    width: 100%;
    height: 150px;
    background: #ffffff;
    box-shadow: 0px 3px 6px -2px rgba(0, 0, 0, 0.12);
    border-radius: 8px;
	position: relative;
	top: -42.5px;
    .left-li {
      width: 100%;
      margin-top: 13px;
	  position: relative;
	  top: 50px;
	  left: 50px;
	  padding-right: 120px;
      img {
        width: 30px;
        margin-left: 10px;
      }
      .li-item {
        width: 145px;
        display: inline-block;
        margin-left: 15px;
        position: relative;
        top: 10px;
        .li-title {
          color: #262626;
          line-height: 20px;
          font-size: 20px;
        }
        .li-desc {
          color: #8c8c8c;
          line-height: 16px;
          font-size: 12px;
        }
      }
    }
    .left-title {
      color: #262626;
      line-height: 24px;
      font-size: 16px;
      margin: 10px 0 0 10px;
      display: inline-block;
    }
    .left-desc {
      color: #8c8c8c;
      line-height: 10px;
      font-size: 10px;
      display: inline-block;
      margin-left: 8px;
    }
    .left-more {
      color: #1890ff;
      line-height: 18px;
      font-size: 14px;
      display: inline-block;
      margin-right: 12px;
	  top: 10px;
      cursor: pointer;
	  position: relative;
	  float: right;
    }
  }
  .bottom-right {
    width: 1000px;
    height: 232px;
    background: #ffffff;
    box-shadow: 0px 3px 6px -2px rgba(0, 0, 0, 0.12);
    border-radius: 8px;
    margin-left: 10px;
    .detail {
      width: 300px;
      height: 114px;
      display: inline-block;
      position: relative;
      top: -0px;
      margin-left: 25px;
      .detail-li {
        width: 140px;
        display: inline-block;
        margin-left: 5px;
        img {
          width: 15px;
        }
        div {
          margin-left: 5px;
          color: #262626;
          line-height: 24px;
          font-size: 14px;
          display: inline-block;
        }
      }
    }
    .bottom-check {
      width: 100%;
      text-align: right;
      .check-title {
        color: #1890ff;
        line-height: 18px;
        font-size: 12px;
        margin-right: 10px;
        margin-top: 10px;
        cursor: pointer;
        z-index: 9999;
        position: relative;
      }
    }
    .bottom-content {
	    width: 967px;
		height: 232px;
	  .content-left{
		  display: inline-block;
		  position: absolute;
		  .total {
			display: inline-block;
			color: #262626;
			line-height: 24px;
			font-size: 14px;
			margin: 0px 0 0 40px;
			position: relative;
			top: -10px;
		  }
		  .circle {
			width: 114px;
			height: 114px;
			border-radius: 57px;
			border: 5px solid #1890ff;
			text-align: center;
			margin: 40px 0 0 40px;
			display: inline-block;
				position: relative;
				left:5px;
			.circle-title {
			  color: #262626;
			  line-height: 48px;
			  font-size: 38px;
			  margin-top: 20px;
			}
			.circle-desc {
			  color: #8c8c8c;
			  line-height: 16px;
			  font-size: 12px;
			}
		  }
	  }
	  .content-right{
		  display: inline-block;
		  position: absolute;
		  margin: 0px 0px 0 350px;
		  .circle1 {
			width: 114px;
			height: 114px;
			border-radius: 57px;
			border: 5px solid #1890ff;
			text-align: center;
			margin: 40px 0px 0 0px;
			display: inline-block;
			position: relative;
			left: 20px;
			.circle-title1 {
			  color: #262626;
			  line-height: 48px;
			  font-size: 38px;
			  margin-top: 20px;
			}
			.circle-desc1 {
			  color: #8c8c8c;
			  line-height: 16px;
			  font-size: 12px;
			}
		  }
		 
		  .circle2 {
			  width: 114px;
			  height: 114px;
			  border-radius: 57px;
			  border: 5px solid #1890ff;
			  text-align: center;
			  margin: 0px 0px 0 40px;
			  display: inline-block;
			  .circle-title2 {
				color: #262626;
				line-height: 48px;
				font-size: 38px;
				margin-top: 20px;
			  }
			  .circle-desc2 {
				color: #8c8c8c;
				line-height: 16px;
				font-size: 12px;
			  }
		  }
	  }
    }
  }
  .bottom-right-big {
    width: 100%;
    height: 232px;
    background: #ffffff;
    box-shadow: 0px 3px 6px -2px rgba(0, 0, 0, 0.12);
    border-radius: 8px;
    .detail {
      width: 300px;
      height: 114px;
      display: inline-block;
      position: relative;
      top: -0px;
      margin-left: 25px;
      .detail-li {
        width: 140px;
        display: inline-block;
        margin-left: 5px;
        img {
          width: 15px;
        }
        div {
          margin-left: 5px;
          color: #262626;
          line-height: 24px;
          font-size: 14px;
          display: inline-block;
        }
      }
    }
    .bottom-check {
      width: 100%;
      text-align: right;
      .check-title {
        color: #1890ff;
        line-height: 18px;
        font-size: 12px;
        margin-right: 10px;
        margin-top: 10px;
        cursor: pointer;
        z-index: 9999;
        position: relative;
      }
    }
    .bottom-content {
  	    width: 967px;
  		height: 232px;
  	  .content-left{
  		  display: inline-block;
  		  position: absolute;
  		  .total {
  			display: inline-block;
  			color: #262626;
  			line-height: 24px;
  			font-size: 14px;
  			margin: 0px 0 0 40px;
  			position: relative;
  			top: -10px;
  		  }
  		  .circle {
  			width: 114px;
  			height: 114px;
  			border-radius: 57px;
  			border: 5px solid #1890ff;
  			text-align: center;
  			margin: 40px 0 0 140px;
  			display: inline-block;
  				position: relative;
  				left:5px;
  			.circle-title {
  			  color: #262626;
  			  line-height: 48px;
  			  font-size: 38px;
  			  margin-top: 20px;
  			}
  			.circle-desc {
  			  color: #8c8c8c;
  			  line-height: 16px;
  			  font-size: 12px;
  			}
  		  }
  	  }
  	  .content-right{
  		  display: inline-block;
  		  position: absolute;
  		  margin: 0px 0px 0 500px;
  		  .circle1 {
  			width: 114px;
  			height: 114px;
  			border-radius: 57px;
  			border: 5px solid #1890ff;
  			text-align: center;
  			margin: 40px 0px 0 0px;
  			display: inline-block;
  			position: relative;
  			left: 20px;
  			.circle-title1 {
  			  color: #262626;
  			  line-height: 48px;
  			  font-size: 38px;
  			  margin-top: 20px;
  			}
  			.circle-desc1 {
  			  color: #8c8c8c;
  			  line-height: 16px;
  			  font-size: 12px;
  			}
  		  }
  		 
  		  .circle2 {
  			  width: 114px;
  			  height: 114px;
  			  border-radius: 57px;
  			  border: 5px solid #1890ff;
  			  text-align: center;
  			  margin: 0px 0px 0 40px;
  			  display: inline-block;
  			  .circle-title2 {
  				color: #262626;
  				line-height: 48px;
  				font-size: 38px;
  				margin-top: 20px;
  			  }
  			  .circle-desc2 {
  				color: #8c8c8c;
  				line-height: 16px;
  				font-size: 12px;
  			  }
  		  }
  	  }
    }
  }
}
</style>